import React from 'react';
import { UserRole } from '../../types/admin';

/**
 * Dropdown for role assignment (Admin/User only)
 * Tenant Admins cannot assign Platform Admin role
 * Requirements: 11.3, 11.4
 */
interface RoleAssignmentSelectProps {
  value: UserRole;
  onChange: (role: UserRole) => void;
  disabled?: boolean;
}

const RoleAssignmentSelect: React.FC<RoleAssignmentSelectProps> = ({ value, onChange, disabled = false }) => {
  // Only allow Admin and User roles for tenant admin assignment
  const allowedRoles = [UserRole.ADMIN, UserRole.USER];

  const getRoleLabel = (role: UserRole) => {
    switch (role) {
      case UserRole.ADMIN:
        return 'Admin';
      case UserRole.USER:
        return 'User';
      default:
        return role;
    }
  };

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as UserRole)}
      disabled={disabled}
      className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-white text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {allowedRoles.map((role) => (
        <option key={role} value={role}>
          {getRoleLabel(role)}
        </option>
      ))}
    </select>
  );
};

export default RoleAssignmentSelect;
